export const MINIMIZED_TITLE = 'Аудиофайл';
export const MINIMIZED_DESC = 'Ссылки и файлы';
